module.exports = __webpack_public_path__ + "media/images/icon-question-b6c4b3f8c11c7cea3c3fdc031efad43d.svg";